import { connect } from 'react-redux'
import { Redirector } from './Redirector'

const mapStateToProps = (state) => ({
  pathToRedirect: state.router.pathToRedirect,
})

export default connect(mapStateToProps)(Redirector)
